import { atom } from "jotai";

export const selectedSearchResultContractAtom = atom({
  word: "",
  activeType: ""
});
selectedSearchResultContractAtom.debugLabel =
  "selectedSearchResultContractAtom";
